<template>
  <div class="container">
    <div id="mattertable">
      <div class="row rowHeader">
        <div class="cell cell01" @click="toggleCol(1)">Client<i class="icon icon-caret" :class="colClasses[colState[1]]"></i></div>
        <div class="cell cell02" @click="toggleCol(2)">Subclass<i class="icon icon-caret" :class="colClasses[colState[2]]"></i></div>
        <div class="draftDocIcon">Draft Document</div>
        <div class="cell cell03" @click="toggleCol(3)">Stage<i class="icon icon-caret" :class="colClasses[colState[3]]"></i></div>
        <div class="cell cell04" @click="toggleCol(4)">Due<i class="icon icon-caret" :class="colClasses[colState[4]]"></i></div>
        <div class="cell cell05 text-center" @click="toggleCol(5)">Who<i class="icon icon-caret" :class="colClasses[colState[5]]"></i></div>
        <div class="cell cell06" @click="toggleCol(6)">Next Step<i class="icon icon-caret" :class="colClasses[colState[6]]"></i></div>
        <div class="cell cell07" @click="toggleCol(7)">Deadline<i class="icon icon-caret" :class="colClasses[colState[7]]"></i></div>
        <div class="cell cell08" @click="toggleCol(8)">Deadline Note<i class="icon icon-caret" :class="colClasses[colState[8]]"></i></div>
        <div class="cell cell09" @click="toggleCol(9)">Sponsor<i class="icon icon-caret" :class="colClasses[colState[9]]"></i></div>
        <div class="cell cell10">Delete</div>
        <!-- <div class="cell cell10 text-center" @click="toggleCol(10)">Dependents<i class="icon icon-caret" :class="colClasses[colState[10]]"></i></div> -->
      </div>

      <div v-for="(row, n) in filtered" class="row" :class="rowClass(row)">
        <div class="cell cell01" @click="s_cell=[n,1]">
          {{row[1]}}
        </div>
        <!-- <div class="cell cell02" @click="s_cell=[n,2]"><router-link :to="'/matters/' + row[0]">{{row[2]}}</router-link></div> -->
        <div class="cell cell02" @click="s_cell=[n,2]">
          {{row[2]}}
        </div>
        <div class="draftDocIcon">
          <router-link :to="'/docs/choosetype/false/' + row[13] + '/' + row[0]"><i class="fa fa-pencil" aria-hidden="true"></i> Draft</router-link>
        </div>
        <div class="cell cell03" @click="s_cell=[n,3]">
          <select v-if="isSelected(n,3)"
                  v-model.number="row[3]"
                  @change.prevent="saveRow(row, true)"
                  @blur="s_cell = [0,0]"
                  v-focus.lazy="true">
            <option value="0">Document Collection</option>
            <option value="1">Drafting Application</option>
            <option value="2">Client Application Review</option>
            <option value="3">Lodged</option>
            <option value="4">RFI</option>
            <option value="5">RFI Complete</option>
            <option value="6">Granted</option>
            <option value="7">Early</option>
            <option value="8">Finalised</option>
            <option value="9">Natural Justice</option>
            <option value="10">Paused</option>
            <option value="11">Refused</option>
            <option value="12">Withdrawn</option>
          </select>
          <div v-else>{{stages[row[3]]}}</div>
        </div>
        <div class="cell cell04" @click="openDate(n,4)">{{dateStr(row[4])}}</div>
        <div class="cell cell05 text-center" @click="s_cell=[n,5]">
          <input v-if="isSelected(n,5)"
                 type="text"
                 v-model="row[5]"
                 @change.prevent="saveRow(row, false)"
                 @blur="s_cell = [0,0]"
                 v-focus.lazy="true">
          <div v-else>{{row[5]}}</div>
        </div>
        <div class="cell cell06" @click="s_cell=[n,6]">
          <input v-if="isSelected(n,6)"
                 type="text"
                 v-model="row[6]"
                 @change.prevent="saveRow(row, false)"
                 @blur="s_cell = [0,0]"
                 v-focus.lazy="true">
          <div v-else>{{row[6]}}</div>
        </div>
        <div class="cell cell07" @click="openDate(n,7)">{{dateStr(row[7])}}</div>
        <div class="cell cell08" @click="s_cell=[n,8]">
          <input v-if="isSelected(n,8)"
                 type="text"
                 v-model="row[8]"
                 @change.prevent="saveRow(row, false)"
                 @blur="s_cell = [0,0]"
                 v-focus.lazy="true">
          <div v-else>{{row[8]}}</div>
        </div>
        <div class="cell cell09" @click="s_cell=[n,9]">
          <input v-if="isSelected(n,9)"
                 type="text"
                 v-model="row[9]"
                 @change.prevent="saveRow(row, false)"
                 @blur="s_cell = [0,0]"
                 v-focus.lazy="true">
          <div v-else>{{row[9]}}</div>
        </div>
          <div class="cell cell10">
            <div class="archive-btn">
              <button class="btn btn-sm" @click="archive(row)">
                <i class="fa fa-file-archive-o" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

    <!-- DATE MODAL -->
    <div class="modal" :class="{active: showDateModal}">
      <div class="modal-overlay"></div>
      <div class="modal-container" id="datebox">
        <div class="modal-header">
          <button class="btn btn-clear float-right" @click="showDateModal = false"></button>
          <div class="modal-title">Change Date</div>
        </div>
        <div class="modal-body">
          <datepicker v-model="chosenDate" :inline="true" v-on:selected="setDate"></datepicker>
        </div>
      </div>
    </div>
    <!-- END DATE MODAL -->

  </div>
</template>

<script>
import axios from 'axios'
import debounce from 'lodash.debounce'
import Datepicker from 'vuejs-datepicker'
import { mixin as focusMixin } from 'vue-focus'

export default {
  name: 'matterTable',
  props: [ 'rows', 'filter', 'showArchived' ],
  components: { datepicker: Datepicker },
  mixins: [ focusMixin ],
  data () {
    return {
      columns: [
        '_id',
        'username',
        'mattername',
        'stage',
        'due',
        'owner',
        'nextstep',
        'deadline',
        'deadlinenote',
        'sponsor',
        'dependents',   // Currently hidden
        'archived',     // row[11]
        'user_archived' // row[12]
      ],
      stages: [
        'Document Collection',
        'Drafting Application',
        'Client Application Review',
        'Lodged',
        'RFI',
        'RFI Complete',
        'Granted',
        'Early',
        'Finalised',
        'Natural Justice',
        'Paused',
        'Refused',
        'Withdrawn'
      ],
      filterStr: '',
      colState: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      colClasses: ['hide', 'caret-down', 'caret-up'],
      s_cell: [0, 0], // Selected cell
      chosenDate: null,
      chosenRow: [],
      chosenRowIndex: 0,
      showDateModal: false,
      now: new Date().getTime()
    }
  },
  computed: {
    filtered: function () {
      if (this.filterStr.trim().length === 0) {
        return this.rows.filter(row => { return (row[11] || row[12]) === this.showArchived })
      }
      let query = this.filterStr.toLowerCase()
      return this.rows.filter(row => {
        return (row[11] || row[12]) === this.showArchived &&
               row[1].toLowerCase().search(query) > -1 ||
               row[2].toLowerCase().search(query) > -1 ||
               row[5].toLowerCase().search(query) > -1
      })
    }
  },
  watch: {
    // Only update the filter string every xxx milliseconds
    filter: debounce(function (f) {
      this.filterStr = f
    }, 300)
  },
  methods: {
    dateStr (d) {
      return d > 0 ? d.toLocaleDateString('en-AU') : null
    },
    isSelected: function (row, col) {
      return this.s_cell[0] === row && this.s_cell[1] === col
    },
    // Mark a row yellow when within two days of its next step
    // red when next step has passed
    // red when within two weeks of its deadline
    // blue when deadline has passed
    rowClass: function (row) {
      if (row[11] || row[12]) return null // If not archived
      if (row[7] > 0) {
        let delta = row[7].getTime() - this.now
        if (delta < 1209600000) {
          if (delta < 0) {
            return 'blue' // deadline passed
          }
          return 'red'    // deadline within two weeks
        }
      }
      if (row[4] > 0) {
        let delta = row[4].getTime() - this.now
        if (delta < 172800000) {
          if (delta < 0) {
            return 'red'  // next step passed
          }
          return 'yellow' // next step within two days
        }
      }
    },
    toggleCol: function (n) {
      var nextState = this.colState[n] === 2 ? 1 : this.colState[n] + 1
      this.colState = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] // Reset all columns
      this.colState.splice(n, 1, nextState)
      this.sortByCol(n)
    },
    sortByCol: function (col) {
      switch (col) {
        case 1: // Unicode
        case 2:
        case 5:
          this.rows.sort((a, b) => { return b[col].localeCompare(a[col]) })
          break
        default: // Numbers and dates
          this.rows.sort((a, b) => { return b[col] - a[col] })
      }

      // Reverse for descending order
      if (this.colState[col] === 2) {
        this.rows.reverse()
      }
    },
    openDate: function (row, col) {
      this.s_cell = [row, col]
      this.chosenDate = this.filtered[row][col]
      this.showDateModal = true
    },
    setDate: function (d) {
      let [row, col] = this.s_cell
      this.filtered[row][col] = d
      this.showDateModal = false
      this.saveRow(this.filtered[row], false)
    },
    archive: function (row) {
      let idx = this.columns.indexOf('archived')
      row[idx] = !row[idx]
      this.filterStr += ' ' // Add a space to trigger the computed property
      this.filterStr.trim()
      this.saveRow(row, false)
    },
    saveRow: function (row, setStage) {
      let update = {}
      this.columns.forEach((colname, i) => { update[colname] = row[i] })
      if (setStage) update.stage_changed_at = new Date()
      axios.post('/api/matters/updateTable', update)
      .then(res => {
        if (res.status === 200) {
          this.s_cell = [0, 0]
        }
      })
      .catch(e => { console.log(e.response.data) })
    }
  }
}
</script>

<style scoped>
.table td {
  padding: 0 .1rem; 
}
#mattertable {
  margin-top: 10px;
}
.caret-up {
  transform: rotate(180deg);
}
.row.rowHeader {
  background-color: #800080;
  color: #fff;
  cursor: pointer
}
.row.rowHeader .cell,
.row.rowHeader .draftDocIcon {
  border: none;
  padding: 5px 0.2em;
  height: inherit;
}
.row {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-basis: 300px;
}
#mattertable .row:nth-child(2n) {
  /*background: #8000801f;*/
  background: #3fa9f526;
}
.archive-btn button {
  background: none!important;
  color: #222!important;
  border: none;
  padding: 0;
  height: auto;
}
.archive-btn button:hover {
  color: #000!important;
}
.draftDocIcon {
    width: 45%;
}
.draftDocIcon a {
  color: #333;
}
.draftDocIcon a:hover {
  text-decoration: none
}
.cell {
  width: 25%;
  padding: 4px;
  overflow: hidden;
  min-height: 26px;
}
.cell.cell10 {
  width:5%
}
.row .cell:last-child {}
.cell a {
  color: #222
}
.cell a:hover {
  border-bottom: 1px solid;
  text-decoration: none
}
.cell input {
  background: #add8e630;
  border: none;
  width: 100%;
  font-weight: 100;
  /*box-shadow: 0 -1px 0 #add8e6;*/
}
.modal.active .modal-container, .modal:target .modal-container {
  max-width: 358px;
  padding: 0 .8em 2em .8em;
}
.cell.cell03, .cell.cell04, .cell.cell05, .cell.cell06, .cell.cell07, .cell.cell08, .cell.cell09 {
    display: none;
}
</style>



// WEBPACK FOOTER //
// table.vue?1cc15502